module.exports = __webpack_public_path__ + "static/media/basketball.5dfa37fa.svg";